import { useMemo } from 'react';
import type { Academy, AcademySport } from '@court-sync/shared';
import {
  getActiveAcademySports,
  isMultiSportAcademy,
  resolvePrimaryAcademySport,
} from '@/lib/sportPresentation';

/** Synthetic tennis sport when API has not yet returned academy_sports rows. */
function fallbackTennisSport(academyId: string): AcademySport {
  const now = new Date();
  return {
    id: `fallback-tennis-${academyId}`,
    academyId,
    sportId: 'tennis',
    isPrimary: true,
    isActive: true,
    createdAt: now,
    updatedAt: now,
  };
}

export function useAcademySports(academy: Academy | null | undefined) {
  return useMemo(() => {
    const fromApi = getActiveAcademySports(academy?.academySports);
    const sports = fromApi.length > 0 ? fromApi : academy?.id ? [fallbackTennisSport(academy.id)] : [];
    const primary = resolvePrimaryAcademySport(sports) ?? sports[0] ?? null;
    return {
      sports,
      primarySport: primary,
      isMultiSport: sports.length > 1,
      sportById: Object.fromEntries(sports.map((s) => [s.id, s])),
    };
  }, [academy]);
}

export { isMultiSportAcademy };
